module.exports = __webpack_public_path__ + "img/logo-smis-gri.06431b9f.svg";